<template>
  <div class="wrap">
    <navigation-skip></navigation-skip>
    <shop-header></shop-header>
    <router-view></router-view>
    <shop-footer></shop-footer>
  </div>
</template>

<script>
import NavigationSkip from '@/views/base/NavigationSkip'
import ShopHeader from '@/views/base/ShopHeader'
import NavigationTop from '@/views/base/NavigationTop'
import ShopFooter from '@/views/base/ShopFooter'
import NavigationBottom from '@/views/base/NavigationBottom'

export default {
  name: 'maintenance',
  components: {
    NavigationSkip,
    ShopHeader,
    NavigationTop,
    ShopFooter,
    NavigationBottom
  },
  data() {
    return {}
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>
